window.PXUTheme.jsFAQ = {
    init() {
      const faqHeadings = document.querySelectorAll('.faq-accordion > dt > button');

      faqHeadings.forEach(function (heading) {
        const targetId = heading.getAttribute('aria-controls');
        const faqIcons = heading.querySelector('.icon');

        heading.addEventListener('click', function () {
          const state = heading.getAttribute('aria-expanded') === 'false';

          heading.setAttribute('aria-expanded', state);
          document.getElementById(targetId).style.display = state ? 'block' : 'none';

          if (faqIcons.classList.contains('icon--active')) {
            faqIcons.classList.toggle('icon--active');
          }

          document.getElementById(targetId).setAttribute('aria-hidden', !state);
          return false;
        });

        heading.addEventListener('keydown', function (event) {
          const keyCode = event.keyCode || event.which;
          if (keyCode === 13) {
            heading.dispatchEvent(new Event('click'));
          }
        });
      });
    },
    unload() {
      const faqHeadings = document.querySelectorAll('.faq-accordion > dt > button');

      faqHeadings.forEach(function (heading) {
        heading.removeEventListener('click', function () {});
        heading.removeEventListener('keydown', function () {});
      });
    },
  };

  // Initialize the script
  window.PXUTheme.jsFAQ.init();